import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { filter, get, values } from 'lodash'

import { Clinician } from '../../model/clinician'
import { CustomQuestionSchema } from '../../schema'
import { PatientIntakeFormData } from '../intake-form-data.class'
import { QuestionBase } from './base.question.class'

export interface TableRow {
  [key: string]: string
}

export class TableQuestion extends QuestionBase<TableRow[]> {
  override controlType = 'table'
  columns: string[]
  multiple = false

  constructor(options: {} = {}) {
    super(options)

    if (this.isCustom) {
      this.columns =
        options['options']['table-opts'].map((obj) => obj.value) || []
    } else {
      this.columns = []
    }
  }

  override set value(value: any) {
    this._value = value
  }

  override get value(): any {
    if (this._value) {
      return this._value
    }
  }

  override toFormControls(fb: UntypedFormBuilder) {
    const tableControl = {}
    for (const field of this.columns) {
      let validators = []
      validators = this.getValidators()
      tableControl[field] = fb.control(get(this.value, field, null), validators)
    }

    this.control = fb.group({
      value: fb.group(tableControl),
      note: fb.control(this.note),
    })

    return {
      [this.id]: this.control,
    }
  }

  override saveValueToData(
    data: PatientIntakeFormData,
    form: UntypedFormGroup,
    clinician: Clinician,
  ) {
    const value = this.value
    const formValue: TableRow | void =
      form.value[this.isCustom ? this.id : this.key].value

    if (formValue && filter(values(formValue)).length > 0) {
      value.push(formValue)
    }

    if (this.isCustom) {
      const question: CustomQuestionSchema = {
        id: this.id,
        value,
        note: form.value[this.id].note,
      }

      data.saveCustomQuestion(question, clinician.id)
    } else {
      data[this.key] = value
    }
  }
}
